import React from 'react';
import { usePermissions } from '../hooks/usePermissions';

interface Props {
  module: string;
  value: string | number;
}

export const ProtectedValue: React.FC<Props> = ({ module, value }) => {
  const { hasPermission } = usePermissions();

  if (!hasPermission(module, 'VER_VALORES')) {
    return <span style={{ background: 'none', color: 'inherit', opacity: 0.55, fontWeight: 'bold' }}>***</span>;
  }

  return <>{value}</>;
};